import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/javierlabs logo transparent.png'


const _hoisted_1 = { class: "Title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "Logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomText = _resolveComponent("CustomText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomText, { tag: "h1" }, {
        default: _withCtx(() => [
          _createTextVNode(" Javier Labs ")
        ]),
        _: 1
      })
    ]),
    _hoisted_2,
    _createElementVNode("div", null, [
      _createVNode(_component_CustomText, { tag: "h2" }, {
        default: _withCtx(() => [
          _createTextVNode(" Software Developer, ML Engineer, and Photographer ")
        ]),
        _: 1
      }),
      _createVNode(_component_CustomText, { tag: "p" }, {
        default: _withCtx(() => [
          _createTextVNode(" I develop software using a myriad of different technologies and shoot photography. ")
        ]),
        _: 1
      })
    ]),
    _hoisted_3
  ], 64))
}